import React from 'react';
import Icon from 'shared/img/test-score.svg';

interface Props {
  size?: number;
  className?: string;
}

const TestScoresIcon = ({size = 50, className}: Props) => (
  <Icon className={className} width={size} height={size} />
);

export default TestScoresIcon;
